import { useState } from "react";
import {
  MDBContainer,
  MDBNavbar,
  MDBNavbarToggler,
  MDBIcon,
  MDBNavbarNav,
  MDBNavbarItem,
  MDBCollapse,
} from "mdb-react-ui-kit";
import Logo from "../../assets/img/polismall.png";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";

export default function Navbar() {
  const [showBasic, setShowBasic] = useState(false);

  const location = useLocation();

  const type = sessionStorage.getItem("type");
  const isClaimRecon = location.pathname.includes("/claim-recon");
  const uniqId = sessionStorage.getItem("uniqId");
  const activePage = sessionStorage.getItem("activePage");

  return (
    <MDBNavbar
      expand="md"
      light
      bgColor="light"
      fixed="top"
      className="shadow-0"
    >
      <MDBContainer fluid>
        <Link to={`${isClaimRecon ? `/claim-recon/${uniqId}` : "/riwayat"}`}>
          <img src={Logo} alt="polismall logo" />
        </Link>

        <MDBNavbarToggler
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
          onClick={() => setShowBasic(!showBasic)}
        >
          <MDBIcon icon="bars" fas />
        </MDBNavbarToggler>

        <MDBCollapse navbar show={showBasic}>
          <MDBNavbarNav right fullWidth={false}>
            {/* <MDBNavbarItem className="py-1 py-md-0 me-md-3">
              <Link
                to="/klaim"
                className={
                  location.pathname === "/klaim" ? "text-body" : "text-dark"
                }
              >
                Klaim
              </Link>
            </MDBNavbarItem> */}
            {(type && type === "public") ||
            (isClaimRecon && activePage === "history-claim-recon") ? (
              <></>
            ) : (
              <MDBNavbarItem className="py-1 py-md-0">
                <Link
                  to={`${isClaimRecon ? `/claim-recon/${uniqId}` : "/riwayat"}`}
                  className={
                    location.pathname === "/riwayat" ||
                    location.pathname === `/claim-recon/${uniqId}`
                      ? "text-body"
                      : "text-dark"
                  }
                >
                  Riwayat
                </Link>
              </MDBNavbarItem>
            )}
          </MDBNavbarNav>
        </MDBCollapse>
      </MDBContainer>
    </MDBNavbar>
  );
}
